module.exports = __webpack_public_path__ + "static/media/14.19df15f8.jpg";